<template>
  <div class="user-task-score-config">
    <div class="header-process">
      <el-row :gutter="10">
        <el-col :span="6">
          <span>渠道:</span>
          <el-select v-model="searchForm.channel" placeholder="请选择" filterable clearable style="width: 180px; margin: 0 5px">
            <el-option
              v-for="item in channelList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <span>类型:</span>
          <el-select v-model="searchForm.type" placeholder="请选择" clearable style="width: 180px; margin: 0 5px">
            <el-option label="普通奖励" :value="1"></el-option>
            <el-option label="高级奖励" :value="2"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <span>状态:</span>
          <el-select v-model="searchForm.valid" placeholder="请选择" clearable style="width: 180px; margin: 0 5px">
            <el-option label="有效" :value="1"></el-option>
            <el-option label="无效" :value="0"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="getConfigList">查询</el-button>
          <el-button type="success" @click="dialogShow(false)">新增</el-button>
        </el-col>
      </el-row>
    </div>
    <el-table :data="configTable" border style="width: 100%" height="600" :show-overflow-tooltip="true">
      <el-table-column prop="id" label="ID" min-width="60"></el-table-column>
      <el-table-column prop="channel" label="渠道" min-width="100"></el-table-column>
      <el-table-column prop="type" label="类型" min-width="80">
        <template slot-scope="scope">
          {{ scope.row.type === 1 ? '普通奖励' : scope.row.type === 2 ? '高级奖励' : scope.row.type || '' }}
        </template>
      </el-table-column>
      <el-table-column prop="score" label="分数" min-width="80"></el-table-column>
      <el-table-column prop="valid" label="状态" min-width="80">
        <template slot-scope="scope">
          {{ scope.row.valid === 1 ? "有效" : "无效" }}
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="操作人" min-width="100"></el-table-column>
      <el-table-column prop="ctime" label="创建时间" min-width="160">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.ctime * 1000) }}
        </template>
      </el-table-column>
      <el-table-column prop="mtime" label="修改时间" min-width="160">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.mtime * 1000) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="300" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="showRewardDialog(scope.row)">奖励明细</el-button>
          <el-button type="warning" size="small" @click="dialogShow(true, scope.row)">编辑</el-button>
          <el-button type="info" size="small" @click="copyConfig(scope.row)">复制</el-button>
          <el-button type="danger" size="small" @click="deleteConfig(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 配置编辑对话框 -->
    <el-dialog
      :title="dialogData.isEdit ? '编辑配置' : '新增配置'"
      :visible.sync="dialogData.visible"
      width="40%"
      :before-close="handleDialogClose"
    >
      <el-form ref="configForm" :model="dialogData.data" label-width="100px">
        <el-form-item label="渠道:" prop="channel">
          <el-select v-model="dialogData.data.channel" placeholder="请选择" filterable style="width: 100%">
            <el-option
              v-for="item in channelList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型:" prop="type">
          <el-select v-model="dialogData.data.type" placeholder="请选择" style="width: 100%">
            <el-option label="普通奖励" :value="1"></el-option>
            <el-option label="高级奖励" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分数:" prop="score">
          <el-input-number v-model="dialogData.data.score" :min="0" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="状态:" prop="valid">
          <el-select v-model="dialogData.data.valid" placeholder="请选择" style="width: 100%">
            <el-option label="有效" :value="1"></el-option>
            <el-option label="无效" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogData.visible = false">取消</el-button>
        <el-button type="primary" @click="submitConfig">确定</el-button>
      </div>
    </el-dialog>

    <!-- 奖励明细对话框 -->
    <el-dialog
      title="奖励明细"
      :visible.sync="rewardDialog.visible"
      width="60%"
    >
      <div style="margin-bottom: 10px">
        <el-button type="primary" size="small" @click="addRewardDialog">添加奖励</el-button>
      </div>
      <el-table :data="rewardDialog.rewardList" border style="width: 100%" :show-overflow-tooltip="true">
        <el-table-column prop="id" label="ID" min-width="60"></el-table-column>
        <el-table-column prop="type" label="奖励类型" min-width="100">
          <template slot-scope="scope">
            {{
              giftTypeList.find(
                (item) => item.value === scope.row.type
              )?.name || scope.row.type || ''
            }}
          </template>
        </el-table-column>
        <el-table-column prop="nums" label="数量" min-width="80"></el-table-column>
        <el-table-column prop="name" label="名称" min-width="120"></el-table-column>
        <el-table-column prop="icon" label="图标" min-width="120">
          <template slot-scope="scope">
            <el-image v-if="scope.row.icon" :src="scope.row.icon" style="width: 50px; height: 50px"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" min-width="100"></el-table-column>
        <el-table-column prop="ctime" label="创建时间" min-width="160">
          <template slot-scope="scope">
            {{ dateFormat(scope.row.ctime * 1000) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="80" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="small" @click="deleteReward(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 添加奖励对话框 -->
    <el-dialog
      title="添加奖励"
      :visible.sync="addRewardDialogData.visible"
      width="40%"
    >
      <el-form ref="rewardForm" :model="addRewardDialogData.data" label-width="100px">
        <el-form-item label="奖励类型:" prop="rewardType">
          <el-select v-model="addRewardDialogData.data.rewardType" placeholder="请选择" filterable style="width: 100%">
            <el-option
              v-for="(item, index) in giftTypeList"
              :key="index"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量:" prop="count">
          <el-input-number v-model="addRewardDialogData.data.count" :min="0" style="width: 100%"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addRewardDialogData.visible = false">取消</el-button>
        <el-button type="primary" @click="submitReward">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UserTaskScoreConfig',
  data() {
    return {
      searchForm: {
        channel: null,
        type: null,
        valid: null,
      },
      channelList: [],
      configTable: [],
      giftTypeList: [],
      dialogData: {
        isEdit: false,
        visible: false,
        data: {
          id: null,
          channel: 'all',
          type: 1,
          score: 0,
          valid: 1,
        },
      },
      rewardDialog: {
        visible: false,
        configId: null,
        rewardList: [],
      },
      addRewardDialogData: {
        visible: false,
        data: {
          rewardType: 1,
          count: 0,
        },
      },
    };
  },
  mounted() {
    this.getChannelList();
    this.getConfigList();
    this.getGiftType();
  },
  methods: {
    dateFormat(input, pattern = '') {
      var dt = new Date(input);
      var y = dt.getFullYear();
      var m = (dt.getMonth() + 1).toString().padStart(2, '0');
      var d = dt.getDate().toString().padStart(2, '0');
      if (pattern.toLowerCase() === 'yyyy-mm-dd') {
        return `${y}-${m}-${d}`;
      } else {
        var hh = dt.getHours().toString().padStart(2, '0');
        var mm = dt.getMinutes().toString().padStart(2, '0');
        var ss = dt.getSeconds().toString().padStart(2, '0');
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
      }
    },
    // 获取渠道列表
    async getChannelList() {
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.channelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token
      );
      if ((res.code != null && res.code != 0) || (res.status != null && res.status != 0)) {
        return this.$message.error(res.message || res.msg || '操作失败');
      }
      this.channelList = [{ channelId: -1, name: 'all', value: 'all' }, ...res.data];
    },
    // 获取配置列表
    async getConfigList() {
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_user_task_score_list,
        this.searchForm,
        {
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
        }
      );
      if ((res.code != null && res.code != 0) || (res.status != null && res.status != 0)) {
        return this.$message.error(res.message || res.msg || '操作失败');
      }
      this.configTable = res.data || [];
    },
    // 显示对话框
    dialogShow(isEdit, row = null) {
      this.dialogData.isEdit = isEdit;
      if (isEdit && row) {
        this.dialogData.data = {
          id: row.id,
          channel: row.channel,
          type: row.type,
          score: row.score,
          valid: row.valid,
        };
      } else {
        this.dialogData.data = {
          id: null,
          channel: 'all',
          type: 1,
          score: 0,
          valid: 1,
        };
      }
      this.dialogData.visible = true;
    },
    // 提交配置
    async submitConfig() {
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_user_task_score_submit,
        this.dialogData.data,
        {
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
        }
      );
      if ((res.code != null && res.code != 0) || (res.status != null && res.status != 0)) {
        return this.$message.error(res.message || res.msg || '操作失败');
      }
      this.$message.success('操作成功');
      this.dialogData.visible = false;
      this.getConfigList();
    },
    // 复制配置
    async copyConfig(row) {
      const copyData = {
        id: null,
        channel: row.channel,
        type: row.type,
        score: row.score,
        valid: 0,
      };
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_user_task_score_submit,
        copyData,
        {
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
        }
      );
      if ((res.code != null && res.code != 0) || (res.status != null && res.status != 0)) {
        return this.$message.error(res.message || res.msg || '操作失败');
      }
      this.$message.success('复制成功');
      this.getConfigList();
    },
    // 删除配置
    async deleteConfig(id) {
      this.$confirm('确定要删除该配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const { data: res } = await this.$axios.get(
            this.$store.getters.path.config_user_task_score_delete,
            {
              params: {
                username: this.$store.getters.username,
                token: this.$store.getters.token,
                id: id,
              },
            }
          );
          if ((res.code != null && res.code != 0) || (res.status != null && res.status != 0)) {
            return this.$message.error(res.message || res.msg || '操作失败');
          }
          this.$message.success('删除成功');
          this.getConfigList();
        })
        .catch(() => {});
    },
    // 显示奖励明细对话框
    async showRewardDialog(row) {
      this.rewardDialog.configId = row.id;
      await this.getRewardList(row.id);
      this.rewardDialog.visible = true;
    },
    // 获取奖励明细列表
    async getRewardList(configId) {
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_user_task_score_reward_list,
        { id: configId },
        {
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
        }
      );
      if ((res.code != null && res.code != 0) || (res.status != null && res.status != 0)) {
        return this.$message.error(res.message || res.msg || '操作失败');
      }
      this.rewardDialog.rewardList = res.data || [];
    },
    // 显示添加奖励对话框
    addRewardDialog() {
      this.addRewardDialogData.data = {
        rewardType: 1,
        count: 0,
      };
      this.addRewardDialogData.visible = true;
    },
    // 提交奖励
    async submitReward() {
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_user_task_score_reward_submit,
        {
          id: this.rewardDialog.configId,
          rewardBo: this.addRewardDialogData.data,
        },
        {
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
        }
      );
      if ((res.code != null && res.code != 0) || (res.status != null && res.status != 0)) {
        return this.$message.error(res.message || res.msg || '操作失败');
      }
      this.$message.success('添加成功');
      this.addRewardDialogData.visible = false;
      this.getRewardList(this.rewardDialog.configId);
    },
    // 删除奖励
    async deleteReward(rewardId) {
      this.$confirm('确定要删除该奖励吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const { data: res } = await this.$axios.get(
            this.$store.getters.path.config_user_task_score_reward_delete,
            {
              params: {
                username: this.$store.getters.username,
                token: this.$store.getters.token,
                rewardInfoId: rewardId,
              },
            }
          );
          if ((res.code != null && res.code != 0) || (res.status != null && res.status != 0)) {
            return this.$message.error(res.message || res.msg || '操作失败');
          }
          this.$message.success('删除成功');
          this.getRewardList(this.rewardDialog.configId);
        })
        .catch(() => {});
    },
    // 关闭对话框
    handleDialogClose() {
      this.dialogData.visible = false;
    },
    // 获取礼物类型
    async getGiftType() {
      const { data: res } = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.const_all,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          className: 'com.quhong.enums.RewardItemType',
        },
      });

      if ((res.code != null && res.code != 0 && res.code != 200) || (res.status != null && res.status != 0 && res.status != 200)) {
        return this.$message.error(res.message || res.msg || '操作失败');
      } else {
        this.giftTypeList = res.data || [];
      }
    },
  },
};
</script>

<style scoped lang="scss">
.user-task-score-config {
  .header-process {
    margin-bottom: 20px;
    
    .el-row {
      .el-col {
        display: flex;
        align-items: center;
        gap: 5px;
        
        span {
          white-space: nowrap;
        }
      }
    }
  }
  
  .el-table {
    .el-table__body-wrapper {
      .el-table__body {
        td {
          padding: 8px 0;
        }
      }
    }
  }
}
</style>

